import { Action, Dispatch } from 'redux'
import { initErrorAction, setEmailErrorAction } from 'reducks/error/actions'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import { push } from 'connected-react-router'

const resetPassword = (email: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initErrorAction())
    dispatch(showLoadingAction())

    return auth
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch(push('/forget/confirm'))
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        console.error(error)
        if (error.code === 'auth/user-not-found') {
          dispatch(setEmailErrorAction('メールアドレスが正しくありません'))
        }
        dispatch(hideLoadingAction())
      })
  }
}

export default resetPassword
